
basePath=wp_vars.site_url;
window.googleAuth=function (response) {
    const jwt = response.credential;
    jQuery.ajax({
        url: basePath+'/wp-content/plugins/mega-pathway/assets/scripts/login-google.php',
        type: 'POST',
        dataType:'html',
        data: {
            'jwt': jwt
        },
        success: function(data) {
            console.log(data);
            jQuery('#loginBox').html(data);
        }
    });
}

jQuery(document).ready(function($){
    $(document).keypress(
        function(event){
            if (event.which == '13' && $('#redirectForm').length) {
                event.preventDefault();
            }
        });
   $(document).on('click','.confirm',function(e){
       e.preventDefault();
       $.ajax({
           url: basePath+'/wp-content/plugins/mega-pathway/assets/scripts/login-google.php',
           type: 'POST',
           dataType:'html',
           data: $('#loginBox form').serialize(),
           success: function(data) {
               console.log(data);
               jQuery('#loginBox').html(data);
           }
       });
   })
});